// extracted by mini-css-extract-plugin
export var content = "_n4-1";
export var fullScreen = "_n4-0";